import React from 'react';

import { Box, CircularProgress, Typography, Grid, Paper } from '@mui/material';

import { useAppSelector } from '../../../common/hooks/reduxHooks';

import Divider from '@mui/material/Divider';

import ScanPackages from './ScanPackages/ScanPackages';

import { paperStyle } from '../../../common/components/tfa-auth/pages/styles';

import './ScanPackageScreen.scss';
import { useNavigate } from 'react-router-dom';
import { FlorencePAGES } from 'src/common/components/tfa-auth/constants/pages';

const ScanPackageScreen: React.FC = () => {
  const { user } = useAppSelector((state) => state.model);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user?.organizationId) {
      const dialog = window.confirm(
        "Organization members don't need to buy scan packages."
      );

      if (dialog) {
        navigate(FlorencePAGES.home);
      }
    }
  }, [user, navigate]);

  const scansAvailableLabel = React.useCallback(() => {
    if (!user) return;

    if (user.purchasedScansAvailable === -1) {
      return 'unlimited';
    }

    if (user.activeSubscriptionType === 'trial') {
      return user.trialScansAvailable + user.purchasedScansAvailable;
    }

    return user.purchasedScansAvailable;
  }, [user]);

  return (
    <Grid
      container
      justifyContent='center'
      alignContent='center'
      style={{
        marginTop: 60,
        marginBottom: 60,
      }}
    >
      <Paper
        elevation={0}
        style={{
          ...paperStyle,
          backgroundColor: '#fbf9f4',
        }}
      >
        <Grid item xs={12} md={12} xl={12}>
          <Box>
            {user && (
              <>
                <div>
                  <Typography fontWeight={500} color='secondary' fontSize={18}>
                    Available scans left
                  </Typography>
                  <Typography fontWeight={600} color='primary' fontSize={20}>
                    {scansAvailableLabel()}
                  </Typography>
                </div>
                <Divider
                  orientation='horizontal'
                  sx={{
                    marginTop: '30px',
                    marginBottom: '30px',
                  }}
                />
                <ScanPackages />
              </>
            )}
            {!user && (
              <CircularProgress
                color='primary'
                size='64px'
                style={{ display: 'block', margin: '24px auto' }}
              />
            )}
          </Box>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default ScanPackageScreen;
